import { useMutation } from "@tanstack/react-query";

import useAxiosPrivate from "../../hooks/useAxiosPrivate";

function useCreateZone() {
  const axiosPrivate = useAxiosPrivate();

  return useMutation({
    mutationFn: ({ request }) => {
      return axiosPrivate({
        method: "POST",
        url: "Zone/Add",
        data: request,
      });
    },
  });
}

export default useCreateZone;
